<section class="@container h-full">
  <div class="flex h-full flex-col gap-2.5 rounded-lg border border-gray-200 bg-gray-50 px-2">
    <iot-platform-ui-filter-engine-v2
      (applyFilters)="onFiltersChange($event)"
      [masterView]="$safeNavigationMigration(masterView()?.toLowerCase())"
      [currentFilters]="filters()"
      [expanded]="true"
      [readonly]="false"
      [suppressOperator]="false"
      class="flex-1 [&_.iot-platform-ui-filter-engine]:!bg-transparent [&_.iot-platform-ui-filter-engine-filter-menu]:!bg-white [&_.iot-platform-ui-filter-engine\_\_clear-all]:!bg-white [&_.iot-platform-ui-filter-engine\_\_group]:!bg-white [&_.mat-expansion-panel]:!bg-transparent [&_.mat-expansion-panel]:!shadow-none"
    />
  </div>
</section>
